import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    TextField,
    Link,
    Button
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

import Box from 'elements/Box';

export default function FormLogin( props: any ) {

    const {
        logo,
        setState,
        setEmail,
        loginData,
        setLoginData,
        loadingButton,
        setLoadingButton,
        sign_in,
        onGoogleSignIn
    } = props;

    
    /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
    /*============================================= */

    /*================================================
    SIGN IN (SUBMIT)
    ================================================*/
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoadingButton(true);
        
        sign_in();

    
    };

    /*================================================
    ================================================*/


    return(
        <Box id='loginBox' className='intent-auth_component'>
            <img className='loginLogo' src={logo} alt="" />
            
            <form onSubmit={handleSubmit} className='form'>
            <TextField
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                value={loginData.email}
                onChange={(e) => {
                    setLoginData({ ...loginData, email: e.target.value });
                    setEmail(e.target.value);
                }}
                type="text"
                autoComplete="email"
                autoFocus
            />
            <TextField
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                value={loginData.password}
                onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
            />
            <LoadingButton
                size="small"
                type="submit"
                loading={loadingButton}
                fullWidth
                variant="contained"
                sx={{ fontSize: '13px', padding: '10px 0px'}}
            >
                INICIAR SESIÓN
            </LoadingButton>

            <LoadingButton
                size="small"
                fullWidth
                variant="outlined"
                sx={{ fontSize: '13px', padding: '10px 0px', marginTop: '10px' }}
                onClick={onGoogleSignIn}
                disabled={loadingButton}
                loading={loadingButton}
                startIcon={<GoogleIcon />}
            >
                Iniciar sesión con Google
            </LoadingButton>

            <Button
                fullWidth
                color="secondary"
                variant="contained"
                onClick={() => setState('signup')}
            >
                CREAR CUENTA
            </Button>


            <div className='intent-auth_links'>
                {/* <Link 
                    component="button"
                    variant="body2"
                    onClick={()=>{
                        setState('signup')
                    }}
                >
                    Don’t Have An Account?
                </Link> */}



                <Link
                    component="button"
                    variant="body2"
                    onClick={() => {
                        setState('forgotPass')
                    }}
                    sx={{ fontSize: '13px', padding: '10px 0px', textDecoration: 'none' }}
                >
                    ¿Olvidaste tu contraseña?
                </Link>
            </div>
            </form>
        </Box>
    );
}